<template>
  <section>
    <div>
      <SeoHero
        :left-image="
          require('~/assets/images/roadbike/Road-bike-left-side.svg')
        "
        :right-image="
          require('~/assets/images/roadbike/Road-bike-right-side.svg')
        "
        left-position="-90px"
        right-position="10px"
        bike-type="road"
        @cta="handleClick"
      >
        Road Bike Insurance <br />
        You Can Rely On
      </SeoHero>

      <div class="container">
        <Featured />
        <RoadBikeCover />
        <RoadBikeInsuranceCover />
        <RideWithConfidence />
        <BlogWidget
          title="Learn more about road bike insurance"
          :slugs="[
            'does-home-insurance-cover-my-bike',
            'can-cyclist-be-sued-cause-accident',
            'can-you-repair-a-carbon-bike',
            'how-much-does-it-cost-to-insure-your-bicycle',
          ]"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import Featured from '@/components/homepage/Featured'
import RoadBikeCover from '@/components/roadbike/RoadBikeCover'
import RoadBikeInsuranceCover from '@/components/roadbike/RoadBikeInsuranceCover'
import RideWithConfidence from '@/components/roadbike/RideWithConfidence'
import SeoHero from '@/components/seo/SeoHero'
import BlogWidget from '@/components/blog-widget/BlogWidget'
import { buildSocialMeta, resolveSocialImage } from '@/helpers/social-meta'
import { productOffer } from '@/helpers/product-offer'

// og:image and Product.image both read this, so the two cannot drift apart.
const OG_IMAGE_PATH = '/images/og/road-bike-insurance-1200x630.png'

// The bike this page is about: drives the CTA href and the modal prefill.
const BIKE_TYPE = 'road'

export default {
  name: 'RoadBikeInsurance',
  components: {
    Featured,
    RoadBikeCover,
    RoadBikeInsuranceCover,
    RideWithConfidence,
    BlogWidget,
    SeoHero,
  },
  data() {
    return {
      page: {
        title: 'Road Bike Insurance (You Can Rely On) | Pedalsure',
        meta_description:
          'Complete road bike cover from Pedalsure. We insure all types of road bikes (and your accessories) against theft, accidental damage, and loads more.',
      },
    }
  },
  head() {
    return {
      title: this.page.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.page.meta_description,
        },
        { hid: 'title', name: 'title', content: this.page.title },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'commuter insurance, road, cycling',
        },
        // og:title/twitter:title derive from this.page.title - the same
        // string driving <title> - so this page cannot again ship another
        // route's title the way it shipped "Mountain Bike Insurance".
        ...buildSocialMeta({
          title: this.page.title,
          description: this.page.meta_description,
          path: this.$route.path,
          image: OG_IMAGE_PATH,
          type: 'website',
        }).meta,
      ],
      script: [
        {
          innerHTML: `
        {
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "Road Bike Insurance",
          "logo": "https://www.pedalsure.com/Pedalsure-Logo_Large.svg",
          "image": ${JSON.stringify([resolveSocialImage(OG_IMAGE_PATH)])},
          "description": "Complete road bike cover from Pedalsure. We insure all types of road bikes (and your accessories) against theft, accidental damage, and loads more.",
           "brand": {
            "@type": "Brand",
            "name": "Pedalsure"
          },
          "offers": ${JSON.stringify(productOffer())}
        }
        `,
          type: 'application/ld+json',
        },
      ],
    }
  },
  methods: {
    ...mapActions('quote', {
      resetQuote: 'resetQuote',
    }),
    handleClick() {
      this.resetQuote()
      // Same values the CTA's href carries, so a quote started from the modal
      // is attributed identically to one started by following the link.
      this.$modal.show('quick-quote', {
        bikeType: BIKE_TYPE,
        src: `lp-${BIKE_TYPE}`,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}
</style>

<style lang="scss" scoped>
/* Hero styling now lives in components/seo/SeoHero.vue */
</style>
